import React from 'react';

import { useTranslation } from 'react-i18next';

import { CurrencyDisplay, type CurrencyDisplayProps } from '@pkg/components';

import { Interior, Label, StyledEstValue } from './styles';

export interface EstValueProps {
    currency?: CurrencyDisplayProps['currency'];
    price?: CurrencyDisplayProps['price'];
    localConversion?: CurrencyDisplayProps['localConversion'];
}

export function EstValue({ currency, price, localConversion }: EstValueProps) {
    const { t: translate } = useTranslation('floorgame');

    return (
        <StyledEstValue>
            <Interior>
                <Label>{translate('est_value_label')}</Label>

                <CurrencyDisplay
                    symbol
                    compact
                    currency={currency}
                    price={price}
                    label={localConversion ? translate('price_game_label') : undefined}
                    localConversion={localConversion}
                />
            </Interior>
        </StyledEstValue>
    );
}
